











































































































































































































































































































































































































































































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class Payment extends Mixins(VueHoduCommon) {

    mounted() : void {
        const tabs = document.querySelectorAll('.tab');
        const tables = document.querySelectorAll('.tableCon');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                // Remove active class from all tabs and tables
                tabs.forEach(t => t.classList.remove('active'));
                tables.forEach(table => table.classList.remove('active'));

                // Add active class to the selected tab and corresponding table
                tab.classList.add('active');
                const target = tab.getAttribute('data-target');
                if( target != null ) {
                    const el = document.getElementById(target);
                    if( el != null ) el.classList.add('active');
                }
            });
        });
    }

    goHoduWeb() : void {
        window.open("https://web.hodu.app/", "_blank");
    }

    /**
     * 고객센터로 이동
     */
    goServiceCenter() : void {
        this.doSetServiceCenterTab(this.ServiceCenterTab.QUESTION);
        this.$router.push('/serviceCenter').catch(e => {});
    }

    /**
     * 주요기능으로 이동
     */
    goFeatures() : void {
        this.doSetFeaturesTab(this.FeaturesTab.CALENDAR);
        this.$router.push('/features').catch(e => {});
    }

    goVoucher() : void {
        window.open("/voucher.html", "_blank");
    }

}

